export const METHOD_TYPE = {
    get: "get",
    post: "post",
    put: "put",
    delete: "delete",
};

export const API_ENDPOINTS = {
    login: 'admin_login',
    getMasterItems: 'get_master_items_admin',
    getUserList: 'get_user_list',
    countUsers: 'count_users',
    countPremiumUsers: 'count_premium_users',
    toggleMasterStatus: 'toggle_master_status',
    countRevenue:'count_revenue',
    getActivity: 'get_activity_admin',
    getAllOrders: 'get_all_orders',
    getUserSearch: 'search_user',
    getOrderSearch: 'search_order',
    updateUserActiveStatus: 'toggle-user-active-status',
    createSubCategories: 'create_activities',
    updateSubCategories: 'update_activities',
    deleteSubCategories: 'delete_activities',
    updateCategoryStatus: 'toggle-act_id-active-status',
    getSearchCategories: 'search_categories',
    getUploadUrl: 'get_url',
}